<template>
  <div tabindex="0" @keydown.esc="mthClearEditmodeFlags">
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <h1>
              Edycja użytkownika
              <b>{{formData[1].value}}</b>
            </h1>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <div md="12"></div>
                <br />

                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <tbody>
                        <tr
                          v-bind:key="field.label"
                          class="productdetailsField"
                          v-for="(field, index) in formData"
                        >
                          <!-- label cell, caption, row header -->
                          <td
                            class="datacell"
                            scope="col"
                            width="30%"
                            :title="index"
                          >{{field.label}}</td>

                          <td class="bold bigger datacell" scope="col">
                            <!-- READ-ONLY -->
                            <span
                              v-if="!field.editMode && (field.type=='txt' || field.type=='txtjson' || field.type=='num') && field.subtype!='cbx'"
                              @click="mthSwitchToEdit(index)"
                              class="editable"
                            >
                              {{field.prefix}}{{mthDisplayValueOrJsonpart(field)}}
                              <span
                                class="light"
                              >{{mthPlaceholderForEmptyValue(field.value)}}</span>
                            </span>
                            <!-- CHECKBOX -->
                            <span v-else-if="field.type == 'checkbox'">
                              <input
                                @change="mthEditLabelSendToDB(index)"
                                type="checkbox"
                                v-bind:true-value="1"
                                v-bind:false-value="0"
                                v-model="field.value"
                              />
                            </span>
                            <span v-else-if="field.subtype == 'cbx'">
                              <input
                                @change="mthProcessBindingHelperThenSendToDb(index)"
                                type="checkbox"
                                v-model="field.tempBindingHelper"
                              />
                            </span>
                            <!-- TEXTBOX -->
                            <span
                              v-else-if="field.type=='txt' || field.type=='txtjson' || field.type=='num'"
                            >
                              <!-- v-on:keyup.enter="mthEditLabelSendToDB(index)" -->
                              <json-input
                                v-on:enterPressed="mthEnterPressed($event,index)"
                                type="text"
                                v-model="field.value"
                                :jsonpart="field.DBfield_jsonpart"
                                :subtype="field.subtype"
                              />
                            </span>
                            <!-- image -->
                            <span v-else-if="field.type=='img'">
                              <table>
                                <tr>
                                  <td width="120">
                                    <img
                                      :key="refresher"
                                      width="120"
                                      :src="mthPreprocessImg(field.value)"
                                    />
                                  </td>
                                  <td width="300">
                                    <!-- IMG_UPLOAD_URL: 'http://gardenpartslen.pl/commonFileDownload.php', -->
                                    <file-upload
                                      :url="mthFileUploadUrl()"
                                      :thumb-url="mthVFileUploadThumbUrl"
                                      :headers="headers"
                                      @change="mthVFileUploadFileChange"
                                      @success="mthVFileUploadFileSuccess"
                                      @error="mthVFileUploadFileError"
                                      @progress="mthVFileUploadFileProgress"
                                      btn-label="Załaduj plik"
                                      btn-uploading-label="Trwa wysyłanie pliku"
                                    ></file-upload>
                                  </td>
                                </tr>
                                <tr></tr>
                              </table>
                            </span>
                            <!-- tree locations by id -->
                            <span v-else-if="field.type=='treelocationsbyid'">
                              <tree-locations-by-product-id
                                :productid="$router.history.current.params.id"
                              ></tree-locations-by-product-id>
                            </span>
                            <!-- dropdown -->
                            <span v-else-if="field.type=='dropdown'">
                              <sql-dropdown v-on:emitedChanged="mthProcessEmitedFromDropdown($event,index)" :displayfield="field.displayfield" :valuefield="field.valuefield" :type="field.tabletype" :orderby="field.orderby" :table="field.dropdownDBtable" :selected="field.value"></sql-dropdown>
                            </span>
                          </td>
                          <td class="narrow datacell">{{field.suffix}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import usersData from "./users/UsersData";
import CTableWrapper from "./base/Table.vue";
import TreeLocationsByProductId from "./b2bisz/TreeLocationsByProductId.vue";
import JsonInput from "./b2bisz/InputJson.vue";
import SqlDropdown from "./b2bisz/SqlDropdown.vue";

export default {
  name: "b2bproductDetails",
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CTableWrapper,
    TreeLocationsByProductId,
    JsonInput,
    SqlDropdown,
  },
  mounted() {
    this.mthFillData();
  },

  data() {
    return {
      refresher: 0,
      headers: { "access-token": "<your-token>" }, //v-imega-upload
      searchValue: "",
      ordersData: [],
      includeTreeID: [], //rows that need treeID as a DBkey1_value in them
      formData: [
        {
          label: "ID użytkownika",
          editable: false,
          visible: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "id",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Nazwa / login",
          editable: true,
          visible: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "login",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Państwo",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "country_id",
          value: "",
          suffix: "",
          prefix: "",
          type: "dropdown",
          tabletype: "nodeletefield",
          dropdownDBtable: "countries",
          displayfield: "polish_shortname",
          valuefield: "iszid",

          orderby: "polish_shortname asc",
          editMode: false,
        },
        {
          label: "Aktywny",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "active",
          value: "",
          suffix: "",
          prefix: "",
          type: "checkbox",
          editMode: false,
        },
        {
          label: "NIP",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "nip",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Nazwa firmy",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "nazwafirmy",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Ulica",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "ulica",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Kod pocztowy",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "kod",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Miasto",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "miasto",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Telefon",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "telefon",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Rabat standardowy %",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "rabat_st",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label:
            "Koszt wysyłki netto w walucie klienta, dla kraju wysyłki (Litwa->Słowacja, jeśli puste - obowiązuje koszt zdefiniowany dla państwa użytkownika)",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "koszt_n",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Zgoda na przetwarzanie danych",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "zgodaNaPrzetwarzanieDanych",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          subtype: "cbx",
          editMode: false,
        },

        {
          label: "Zgoda na faktury elektroniczne",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "zgodaNaFakturyElektroniczne",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          subtype: "cbx",
          editMode: false,
        },
        {
          label:
            "Płatność przelewem (1 - Tak, 0 - Nie, 2 - Zawsze zablokowane)",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "placiPrzelewem",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Zablokowane zamówienie przeds. (1 - Tak, 0 - Nie)",
          editable: true,
          visible: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "przedsezon_zakonczone",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Zatwierdzone zamówienie przeds. (1 - Tak, 0 - Nie)",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "zamowieniePrzedsezonZatwierdzone",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "VAT UE (1 - Tak, 0 - Nie)",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "extras",
          DBfield_jsonpart: "vatUE",
          value: "",
          suffix: "",
          prefix: "",
          type: "txtjson",
          editMode: false,
        },
        {
          label: "Generuj CSV (dawniej: CSV autoemail)",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "otrzymuje_csv_mailem_raz_na_dobe",
          value: "",
          suffix: "",
          prefix: "",
          type: "checkbox",
          editMode: false,
        },
        {
          label: "Zezwalam na wysyłanie CSV mailem ",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "otrzymuje_csv_mailem_raz_na_dobeADMIN_CONFIRMATION",
          value: "",
          suffix: "",
          prefix: "",
          type: "checkbox",
          editMode: false,
        },
        {
          label: "Dealer Zongshen",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "dealer_zongshen",
          value: "",
          suffix: "",
          prefix: "",
          type: "checkbox",
          editMode: false,
        },
        {
          label: "Bezpłatna dostawa od kwoty (PLN netto)",
          editable: true,
          visible: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "bezplatna_przesylka_od",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Specjalny termin płatności (dni)",
          editable: true,
          visible: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "specialPaymentDaysUser",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Handlowiec",
          editable: true,
          DBtable: "user",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "handlowiec",
          value: "",
          suffix: "",
          prefix: "",
          type: "dropdown",
          tabletype: "",
          dropdownDBtable: "handlowcy",
          displayfield: "imie",
          valuefield: "id",
          editMode: false,
          orderby: "imie asc",
        },

      ],
    };
  },
  created() {
    //console.log(this.$router);
    //console.log(this.$router.history.current.params.id);
  },
  methods: {
    mthProcessEmitedFromDropdown(event,index){

      //event: native from textarea or {text: 'bla'} from vue2-editor
      
      // console.log('got countryid: ');
      // console.log(event.target.value);
      // console.log('got index: ');
      // console.log(index);

      this.formData[index].value=event.target.value;
      this.mthEditLabelSendToDB(index);
    },
    mthFillBindingHelpers() {
      console.log("filling binding helpers");

      var trueMess = ["TAK", "on", "Tak", "ON", "On"];

      this.formData.forEach(function (item, index) {
        if (
          (item.DBfield_jsonpart == "zgodaNaPrzetwarzanieDanych" &&
            trueMess.includes(
              JSON.parse(item.value)["zgodaNaPrzetwarzanieDanych"]
            )) ||
          (item.DBfield_jsonpart == "zgodaNaFakturyElektroniczne" &&
            trueMess.includes(
              JSON.parse(item.value)["zgodaNaFakturyElektroniczne"]
            ))
        ) {
          item.tempBindingHelper = true;
        } else {
          item.tempBindingHelper = false;
        }
      });
    },
    mthProcessBindingHelperThenSendToDb(index) {
      var tempBindingHelper = this.formData[index].tempBindingHelper;
      //console.log('mthProcessBindingHelperThenSendToDb: tempBindingHelper helper is');
      //console.log(tempBindingHelper);

      var item = this.formData[index];
      var jobj = JSON.parse(item.value);

      //zgoda na przetwarzanie danych
      if (item.DBfield_jsonpart == "zgodaNaPrzetwarzanieDanych") {
        if (tempBindingHelper == true) jobj.zgodaNaPrzetwarzanieDanych = "on";
        else jobj.zgodaNaPrzetwarzanieDanych = "";
      }

      //zgodaNaFakturyElektroniczne
      if (item.DBfield_jsonpart == "zgodaNaFakturyElektroniczne") {
        if (tempBindingHelper == true) jobj.zgodaNaFakturyElektroniczne = "on";
        else jobj.zgodaNaFakturyElektroniczne = "";
      }

      item.value = JSON.stringify(jobj);

      this.mthEditLabelSendToDB(index);
    },
    mthEnterPressed(event, index) {
      var json = false;
      var itemToDb = this.formData[index];
      if (
        itemToDb.DBfield_jsonpart !== undefined &&
        itemToDb.DBfield_jsonpart != ""
      ) {
        json = true;
      }
      var valuetodb = itemToDb.value;

      // console.log('modified value is');
      // console.log(event.target.value);
      // console.log('index is');
      // console.log(index);

      if (json) {
        var valuetodbobj = JSON.parse(itemToDb.value);

        if (
          itemToDb.DBfield_jsonpart !== undefined &&
          itemToDb.DBfield_jsonpart != ""
        ) {
          console.log("tryin to write");
          console.log(event.target.value);
          valuetodbobj[itemToDb.DBfield_jsonpart] = event.target.value;
          valuetodb = JSON.stringify(valuetodbobj);
        }
      } //if json
      else {
        valuetodb = event.target.value;
      }

      this.formData[index].value = valuetodb;
      //console.log('formdata ');
      //console.log(this.formData[index]);
      console.log("mthEnterPressed: to db will go " + valuetodb);
      this.mthEditLabelSendToDB(index);
    },
    mthDisplayValueOrJsonpart(field) {
      if (
        field.DBfield_jsonpart !== undefined &&
        field.DBfield_jsonpart != "" &&
        field.value != ""
      ) {
        var obj = JSON.parse(field.value);

        return obj[field.DBfield_jsonpart];
      }
      return field.value;
    },
    mthFileUploadUrl() {
      return (
        process.env.VUE_APP_IMG_UPLOAD_URL +
        "?id=" +
        this.$router.history.current.params.id +
        "&toname=" +
        this.formData[8].value
      );
    },
    mthPlaceholderForEmptyValue(value) {
      //console.log(value);
      //if value is empty, there is no place to click for edit...
      if (value == "" || value==null) return "(pole jest puste, kliknij aby edytować(4))";
      return "";
    },
    mthVFileUploadThumbUrl() {},
    mthVFileUploadFileChange() {},
    mthVFileUploadFileSuccess() {
      var miliseconds = new Date().getTime();
      this.refresher = miliseconds;
      this.mthFillFormData2();
    },
    mthVFileUploadFileError() {},
    mthVFileUploadFileProgress() {},
    mthPreprocessImg(src) {
      var ret = src;
      ret = process.env.VUE_APP_GP_URL + src + "?nocache=" + this.refresher;
      return ret;
    },
    mthClearEditmodeFlags() {
      //this.formData.each(function(index,item){item.editMode=false;});

      this.formData.forEach((element) => {
        element.editMode = false;
      });
    },
    mthSwitchToEdit(index) {
      this.mthClearEditmodeFlags();

      if (this.formData[index].editable) this.formData[index].editMode = true;
    },
    mthEditLabelSendToDB(index) {
      var that = this;
      var data = this.formData[index];
      if (data.type == "checkbox") {
      }
      if (data.type == "num") {
        data.value.replace(".", ",");
      }
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bsetattrvalfromtbl?tbln=" +
        data.DBtable +
        "&key1n=" +
        data.DBkey1_name +
        "&key1v=" +
        data.DBkey1_value +
        "&key2n=" +
        data.DBkey2_name +
        "&key2v=" +
        data.DBkey2_value +
        "&fieldn=" +
        data.DBfield +
        "&data=" +
        encodeURIComponent(data.value) +
        "&index=" +
        index +
        "&datatype=" +
        data.type;

      console.log("mthEditLabelSendToDB AXIOS: to db will go ");
      console.log(data.value);

      //console.log("formdata[index]");
      //console.log(this.formData[index]);

      const options = { method: "get", url: apiurl };
      this.$axios(options)
        .then(function (response) {
          that.formData[index].editMode = false;
          that.mthFillFormData2();
        })
        .catch(function (error) {
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthFillFormData2() {
      var data;
      var section = "";
      var that = this;

      var requestsArray = [];

      this.formData.forEach(function (item, index) {
        var apiurl =
          process.env.VUE_APP_API_URL +
          "/api/v1/b2bgetattrvalfromtbl?tbln=" +
          item.DBtable +
          "&key1n=" +
          item.DBkey1_name +
          "&key1v=" +
          item.DBkey1_value +
          "&key2n=" +
          item.DBkey2_name +
          "&key2v=" +
          item.DBkey2_value +
          "&fieldn=" +
          item.DBfield +
          "&index=" +
          index;

        requestsArray.push(that.$axios.get(apiurl));
      });

      //magic, multiple requests with axios

      that.$axios
        .all(requestsArray)
        .then(
          that.$axios.spread((...responses) => {
            responses.forEach((r) => {
              if (r.data.value == "") return;
              that.formData[r.data.index].value = r.data.value;
            });

            that.mthFillBindingHelpers();
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
      //end of magic
    },
    // mthFillFormData() {
    //   var data;
    //   var section = "";
    //   var that = this;

    //   //var formdata2=this.formData;
    //   //for (var i = 0; i < this.formData.length; i++) {
    //   this.formData.forEach(function (item, index) {
    //     //zaladuj id do tablic
    //     var apiurl =
    //       process.env.VUE_APP_API_URL +
    //       "/api/v1/b2bgetattrvalfromtbl?tbln=" +
    //       item.DBtable +
    //       "&key1n=" +
    //       item.DBkey1_name +
    //       "&key1v=" +
    //       item.DBkey1_value +
    //       "&key2n=" +
    //       item.DBkey2_name +
    //       "&key2v=" +
    //       item.DBkey2_value +
    //       "&fieldn=" +
    //       item.DBfield +
    //       "&index=" +
    //       index;

    //     that
    //       .$axios({
    //         method: "get",
    //         url: apiurl,
    //       })
    //       .then(function (response) {
    //         if (response.data.value == "") return;
    //         that.formData[response.data.index].value = response.data.value;
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //         that.loginsuccess = false;
    //         that.loginresultmsg = "Brak połączenia z API (" + error + ").";
    //       });
    //   }); //forEach
    // },
    shuffleArray(array) {
      for (let i = array.length; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return false;
    },

    getShuffledOrdersData() {
      return this.shuffleArray(this.ordersData.slice(0));
    },
    mthFillData() {
      //zaladuj id do tablic
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/api/v1/b2bgetattrvalfromtbl?tbln=katalog_products&key1n=id" +
        "&key1v=" +
        this.$router.history.current.params.id +
        "&key2n=&key2v=&fieldn=tree_id";

      var that = this;
      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          //fill treeID
          for (let i = 0; i < that.includeTreeID.length; i++) {
            var rowNum = that.includeTreeID[i];
            that.formData[rowNum].DBkey1_value = response.data.value;
          }
          that.mthFillFormData2();
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
  },
};
</script>

<style scoped>
@import "./styles/products.css";
input[type="text"] {
  width: 100%;
  background-color: yellow;
  height: 100%;
}
.bold {
  font-weight: bold;
}
.bigger {
  font-size: 14pt;
}
.datacell {
  padding-top: 4px;
}
.narrow {
  width: 12%;
}
.imgcell {
  display: inline;
}
.light {
  color: lightgray;
}
</style>
